import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  store(key: string, value: unknown): void {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  retrieve<T = unknown>(key: string): T | null {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  }

  remove(key: string): void {
    window.localStorage.removeItem(key);
  }

  clear(): void {
    window.localStorage.clear();
  }
}

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  store(key: string, value: unknown): void {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  }

  retrieve<T = unknown>(key: string): T | null {
    const raw = window.sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  }

  remove(key: string): void {
    window.sessionStorage.removeItem(key);
  }

  clear(): void {
    window.sessionStorage.clear();
  }
}
